import { createGradient } from 'components/maps/EditMap/HeatmapLayer/heatmapLayer';

export const CHOROPLETH_VALUE_PROPERTY = '__choroplethValue';
export const CHOROPLETH_LAYER_ID = 'electorate-fill';

export const boundariesLayer = (lineColor = '#165391', lineWidth = 2) => ({
  id: 'electorate',
  type: 'line',
  source: 'boundaries',
  layout: {
    'line-cap': 'round',
    'line-join': 'round',
  },
  paint: {
    'line-color': lineColor,
    'line-width': lineWidth,
    'line-opacity': 1,
  },
});

const flattenBoundaryFeatures = (boundaryShape) => {
  if (!boundaryShape) {
    return [];
  }

  if (boundaryShape.type === 'FeatureCollection') {
    return boundaryShape.features || [];
  }

  return [boundaryShape];
};

export const choroplethBoundariesLayer = (
  heatmapGradient = {},
  choroplethRange = {},
) => {
  const { min, max } = choroplethRange;
  const colors = createGradient(heatmapGradient, [min, (min + max) / 2, max]);

  if (min === undefined || max === undefined || colors.length === 0) {
    return {
      id: CHOROPLETH_LAYER_ID,
      type: 'fill',
      source: 'boundaries',
      paint: {
        'fill-color': 'rgba(0,0,0,0)',
        'fill-opacity': 0,
      },
    };
  }

  return {
    id: CHOROPLETH_LAYER_ID,
    type: 'fill',
    source: 'boundaries',
    paint: {
      'fill-color': min === max
        ? ['case', ['has', CHOROPLETH_VALUE_PROPERTY], heatmapGradient.highestValue, 'rgba(0,0,0,0)']
        : ['case', ['has', CHOROPLETH_VALUE_PROPERTY], ['interpolate', ['linear'], ['get', CHOROPLETH_VALUE_PROPERTY], ...colors], 'rgba(0,0,0,0)'],
      'fill-opacity': ['case', ['has', CHOROPLETH_VALUE_PROPERTY], 0.72, 0],
    },
  };
};

export const createBoundaries = (
  boundariesShapes,
  { mapShapes = [], choroplethValuesByMapShapeId = {} } = {},
) => {
  const features = boundariesShapes.flatMap((boundaryShape, index) => {
    const mapShape = mapShapes[index];
    const choroplethValue = mapShape ? choroplethValuesByMapShapeId[String(mapShape.id)] : undefined;

    return flattenBoundaryFeatures(boundaryShape).map(feature => ({
      ...feature,
      properties: {
        ...feature.properties,
        ...(choroplethValue === undefined ? {} : { [CHOROPLETH_VALUE_PROPERTY]: choroplethValue }),
      },
    }));
  });

  return {
    type: 'FeatureCollection',
    features,
  };
};
